'use client'

type FCC<Props = Record<string, unknown>> = React.FC<
  React.PropsWithChildren<Props>
>

const TypographyText: FCC<{ className?: string; tagName?: 'p' | 'div' }> = ({
  className,
  children,
  tagName = 'p'
}) => {
  const Tag = tagName
  return <Tag className={className}>{children}</Tag>
}

export { TypographyText }
